module.exports = __webpack_public_path__ + "static/media/u31_1.4fadf75e.mp3";